export const translations = {
  en: {
    // Header Navigation
    mission: "Mission",
    gallery: "Gallery",
    location: "Location",
    contact: "Contact",
    
    // Company Info
    companyName: "CALYPSO EVENT GROUP",
    tagline: "Creating Unforgettable Moments",
    
    // Mission Section
    missionTitle: "Our Mission",
    missionText: "Provide a high-quality service, transforming each event into a unique and memorable experience, exceeding our clients' expectations with Creativity, Professionalism and Attention to detail.",
    
    // Gallery Categories
    weddings: "Weddings",
    quinceaneras: "Quinceañeras",
    events: "Events",
    
    weddingsDesc: "Dream weddings designed to your measure",
    quinceanerasDesc: "Celebrate your 15 years with style and elegance",
    eventsDesc: "Corporate events and special celebrations",
    
    // Gallery Image Titles
    romanticFirstDance: "Romantic First Dance",
    specialMoment: "Special Moment",
    festiveAtmosphere: "Festive Atmosphere",
    unforgettableCelebration: "Unforgettable Celebration",
    danceAndFun: "Dance and Fun",
    professionalSetup: "Professional Setup",
    fullDanceFloor: "Full Dance Floor",
    greenElegantLighting: "Green Elegant Lighting",
    purpleSophisticatedAmbience: "Purple Sophisticated Ambience",
    
    elegantQuinceanera: "Elegant Quinceañera",
    festiveEnvironment: "Festive Environment",
    specialCelebration: "Special Celebration",
    dreamParty: "Dream Party",
    magicalMoment: "Magical Moment",
    
    spectacularAmbience: "Spectacular Ambience",
    corporateEvent: "Corporate Event",
    professionalLighting: "Professional Lighting",
    
    // Location Section
    locationTitle: "Our Service Area",
    city: "Columbus, Ohio",
    area: "Service area: Highway 270 Perimeter",
    
    // Contact Section
    contactTitle: "Contact Us",
    contactSubtitle: "We are available on multiple platforms",
    facebook: "Facebook",
    instagram: "Instagram",
    whatsapp: "WhatsApp",
    tiktok: "TikTok",
    email: "Email",
    phone: "Phone",
    
    // Quote Form
    requestQuote: "Request a Quote",
    quoteModalTitle: "Request Quote",
    fullName: "Full Name",
    emailAddress: "Email",
    phoneNumber: "Phone",
    eventDate: "Event Date",
    selectDate: "Select a date",
    approximateGuests: "Approximate Number of Guests",
    additionalMessage: "Additional Message",
    sendWhatsApp: "Send via WhatsApp",
    required: "*",
    
    // Quote Form Placeholders
    fullNamePlaceholder: "Your full name",
    emailPlaceholder: "your@email.com",
    phonePlaceholder: "(614) 123-4567",
    guestsPlaceholder: "Ex: 100",
    messagePlaceholder: "Tell us more details about your event...",
    
    // Quote WhatsApp Message
    quoteRequest: "Quote Request",
    name: "Name",
    eventDateLabel: "Event Date",
    numberOfGuests: "Number of Guests",
    additionalMessageLabel: "Additional Message",
    notProvided: "Not provided",
    notSpecified: "Not specified",
    none: "None",
    generatedFrom: "Request generated from calypsoeventgroup.com",
    
    // Validation Messages
    fillRequiredFields: "Please complete the required fields: Name, Phone and Event Date",
    
    // General
    generalInquiry: "General Inquiry",
    
    // Language Selector
    language: "Language",
    english: "English",
    spanish: "Español"
  },
  es: {
    // Header Navigation
    mission: "Misión",
    gallery: "Galería",
    location: "Ubicación",
    contact: "Contacto",
    
    // Company Info
    companyName: "CALYPSO EVENT GROUP",
    tagline: "Creando Momentos Inolvidables",
    
    // Mission Section
    missionTitle: "Nuestra Misión",
    missionText: "Brindar un servicio de alta calidad, transformando cada evento en una experiencia única y memorable, superando las expectativas de nuestros clientes con Creatividad, Profesionalismo y Atención al detalle.",
    
    // Gallery Categories
    weddings: "Bodas",
    quinceaneras: "Quinceañeras",
    events: "Eventos",
    
    weddingsDesc: "Bodas de ensueño diseñadas a tu medida",
    quinceaneasDesc: "Celebra tus 15 años con estilo y elegancia",
    eventsDesc: "Eventos corporativos y celebraciones especiales",
    
    // Gallery Image Titles
    romanticFirstDance: "Primer Baile Romántico",
    specialMoment: "Momento Especial",
    festiveAtmosphere: "Ambiente Festivo",
    unforgettableCelebration: "Celebración Inolvidable",
    danceAndFun: "Baile y Diversión",
    professionalSetup: "Setup Profesional",
    fullDanceFloor: "Pista de Baile Llena",
    greenElegantLighting: "Iluminación Verde Elegante",
    purpleSophisticatedAmbience: "Ambiente Morado Sofisticado",
    
    elegantQuinceanera: "Quinceañera Elegante",
    festiveEnvironment: "Ambiente Festivo",
    specialCelebration: "Celebración Especial",
    dreamParty: "Fiesta de Ensueño",
    magicalMoment: "Momento Mágico",
    
    spectacularAmbience: "Ambiente Espectacular",
    corporateEvent: "Evento Corporativo",
    professionalLighting: "Iluminación Profesional",
    
    // Location Section
    locationTitle: "Nuestra Área de Servicio",
    city: "Columbus, Ohio",
    area: "Área de servicio: Perímetro Highway 270",
    
    // Contact Section
    contactTitle: "Contáctanos",
    contactSubtitle: "Estamos disponibles en múltiples plataformas",
    facebook: "Facebook",
    instagram: "Instagram",
    whatsapp: "WhatsApp",
    tiktok: "TikTok",
    email: "Email",
    phone: "Teléfono",
    
    // Quote Form
    requestQuote: "Solicita una Cotización",
    quoteModalTitle: "Solicitar Cotización",
    fullName: "Nombre Completo",
    emailAddress: "Email",
    phoneNumber: "Teléfono",
    eventDate: "Fecha del Evento",
    selectDate: "Selecciona una fecha",
    approximateGuests: "Número Aproximado de Invitados",
    additionalMessage: "Mensaje Adicional",
    sendWhatsApp: "Enviar por WhatsApp",
    required: "*",
    
    // Quote Form Placeholders
    fullNamePlaceholder: "Tu nombre completo",
    emailPlaceholder: "tu@email.com",
    phonePlaceholder: "(614) 123-4567",
    guestsPlaceholder: "Ej: 100",
    messagePlaceholder: "Cuéntanos más detalles sobre tu evento...",
    
    // Quote WhatsApp Message
    quoteRequest: "Solicitud de Cotización",
    name: "Nombre",
    eventDateLabel: "Fecha del Evento",
    numberOfGuests: "Número de Invitados",
    additionalMessageLabel: "Mensaje Adicional",
    notProvided: "No proporcionado",
    notSpecified: "No especificado",
    none: "Ninguno",
    generatedFrom: "Solicitud generada desde calypsoeventgroup.com",
    
    // Validation Messages
    fillRequiredFields: "Por favor completa los campos obligatorios: Nombre, Teléfono y Fecha del Evento",
    
    // General
    generalInquiry: "Consulta General",
    
    // Language Selector
    language: "Idioma",
    english: "English",
    spanish: "Español"
  }
};
